import React, { useState, useContext, useEffect } from "react";
import api from "../../api/axiosConfig";
import { TfiFilter } from "react-icons/tfi";
import { useParams } from "react-router-dom";
import { ProjectContext } from "../../App";
import { useAuth } from "../Authentication/AuthContext";
import { FaCheckCircle } from "react-icons/fa";
import { FaChevronRight } from "react-icons/fa";
import { FaChevronDown } from "react-icons/fa";

const RfiFilter = ({ setFilter, isFilterActive }) => {
  const { dialBoxopen } = useContext(ProjectContext);
  const { userDetails } = useAuth();
  const [users, setUsers] = useState([]);
  const [phases, setPhases] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);

  const [selectedPreparedBy, setSelectedPreparedBy] = useState([]);
  const [selectedReviewedBy, setSelectedReviewedBy] = useState([]);
  const [selectedApprovedBy, setSelectedApprovedBy] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [selectedPhase, setSelectedPhase] = useState([]);

  const [preparedByCondition, setPreparedByCondition] = useState("is");
  const [reviewedByCondition, setReviewedByCondition] = useState("is");
  const [approvedByCondition, setApprovedByCondition] = useState("is");
  const [phaseCondition, setPhaseCondition] = useState("is");
  const [statusCondition, setStatusCondition] = useState("is");

  const { projectId } = useParams();

  const [preparedByUsersOpen, setPreparedByUsersOpen] = useState(true);
  const [reviewedByUsersOpen, setReviewedByUsersOpen] = useState(true);
  const [approvedByUsersOpen, setApprovedByUsersOpen] = useState(true);
  const [phaseOpen, setPhaseOpen] = useState(true);
  const [statusOpen, setStatusOpen] = useState(true);

  useEffect(() => {
    if (!isFilterActive) {
      setSelectedPreparedBy([]);
      setSelectedReviewedBy([]);
      setSelectedApprovedBy([]);
      setSelectedPhase([]);
      setSelectedStatus([]);
      setPreparedByCondition("is");
      setReviewedByCondition("is");
      setApprovedByCondition("is");
      setPhaseCondition("is");
      setStatusCondition("is");
      setPhaseOpen(true);
      setStatusOpen(true);
      setPreparedByUsersOpen(true);
      setReviewedByUsersOpen(true);
      setApprovedByUsersOpen(true);
    }
  }, [isFilterActive]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [usersRes, phaseRes] = await Promise.all([
          api.get(`/api/projects/${projectId}/users`),
          api.get(`/api/project/${projectId}/phases`),
        ]);

        const activeUsers = usersRes.data.filter(
          (member) => member.status !== "Inactive"
        );
        setUsers(activeUsers);
        setPhases(phaseRes.data?.phases);
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, [projectId]);

  const handleApplyFilters = () => {
    if (selectedPreparedBy.length > 0) {
      setFilter((prev) => ({
        ...prev,
        prepared_by: selectedPreparedBy,
        prepared_by_condition: preparedByCondition,
      }));
    }

    if (selectedReviewedBy.length > 0) {
      setFilter((prev) => ({
        ...prev,
        reviewed_by: selectedReviewedBy,
        reviewed_by_condition: reviewedByCondition,
      }));
    }

    if (selectedApprovedBy.length > 0) {
      setFilter((prev) => ({
        ...prev,
        approved_by: selectedApprovedBy,
        approved_by_condition: approvedByCondition,
      }));
    }

    if (selectedPhase.length > 0) {
      setFilter((prev) => ({
        ...prev,
        selected_phase: selectedPhase,
        phase_condition: phaseCondition,
      }));
    }

    if (selectedStatus.length > 0) {
      setFilter((prev) => ({
        ...prev,
        selected_status: selectedStatus,
        status_condition: statusCondition,
      }));
    }
    setOpenDialog(false);
  };

  const toggleUserSelection = (user_details) => {
    // Check if the user is already selected
    if (selectedPreparedBy.includes(user_details.name)) {
      // Remove user from the selectedPreparedBy array
      setSelectedPreparedBy(
        selectedPreparedBy.filter((selected) => selected !== user_details.name)
      );
    } else {
      // Add user to the selectedPreparedBy array
      setSelectedPreparedBy([...selectedPreparedBy, user_details.name]);
    }
  };

  const toggleReviewedBySelection = (user_details) => {
    // Check if the user is already selected
    if (selectedReviewedBy.includes(user_details.name)) {
      // Remove user from the selectedPreparedBy array
      setSelectedReviewedBy(
        selectedReviewedBy.filter((selected) => selected !== user_details.name)
      );
    } else {
      // Add user to the selectedPreparedBy array
      setSelectedReviewedBy([...selectedReviewedBy, user_details.name]);
    }
  };

  const toggleApprovedSelection = (user_details) => {
    // Check if the user is already selected
    if (selectedApprovedBy.includes(user_details.name)) {
      setSelectedApprovedBy(
        selectedApprovedBy.filter((selected) => selected !== user_details.name)
      );
    } else {
      setSelectedApprovedBy([...selectedApprovedBy, user_details.name]);
    }
  };

  return (
    <div>
      <div>
        <button
          onClick={() => setOpenDialog(true)}
          style={{ border: "none" }}
          title="Filter"
        >
          <TfiFilter
            className="relative border-none text-[#6200ee] h-[20px] w-[20px] cursor-pointer"
            style={{ zIndex: "9" }}
          />
        </button>
      </div>

      {openDialog && (
        <div
          className={`timesheet-filter-dial ${dialBoxopen ? "open" : "close"}`}
        >
          <div className="filter-overview-con">
            <div className="new-time-log">
              <h3
                style={{
                  backgroundColor: "transparent",
                  marginLeft: "10px",
                  marginTop: "5px",
                }}
              >
                Filter Options
              </h3>
            </div>
            <div className="timesheet-scrollable-t-content">
              <div
                className={
                  preparedByUsersOpen
                    ? "accordion-u-header"
                    : "accordion-header"
                }
                style={{ marginBottom: "-1px", borderTop: "none" }}
              >
                <h3
                  className="accordion-label"
                  onClick={() => setPreparedByUsersOpen((prev) => !prev)}
                >
                  Prepared by
                  {selectedPreparedBy.length > 0 && (
                    <span className="users-count">
                      {selectedPreparedBy.length}
                    </span>
                  )}
                </h3>
                {!preparedByUsersOpen && (
                  <select
                    className="is-not"
                    value={preparedByCondition}
                    onChange={(e) => setPreparedByCondition(e.target.value)}
                  >
                    <option value="is">Is</option>
                    <option value="not">Is Not</option>
                  </select>
                )}

                <span
                  onClick={() => setPreparedByUsersOpen((prev) => !prev)}
                  className="span-element"
                >
                  {preparedByUsersOpen ? (
                    <FaChevronRight className="arrow-icon" />
                  ) : (
                    <FaChevronDown className="arrow-d-icon" />
                  )}
                </span>
              </div>

              <div
                className={preparedByUsersOpen ? "hide" : "filter-name-field"}
                style={{
                  height:
                    userDetails.role_name === "Administrator" ||
                    userDetails.role_name === "Super Admin"
                      ? "133px"
                      : "auto",
                }}
              >
                {userDetails.role_name === "Administrator" ||
                userDetails.role_name === "Project_Manager" ||
                userDetails.role_name === "Super Admin" ? (
                  <ul className="user-ul">
                    {users
                      .sort((a, b) => a.name.localeCompare(b.name)) // Sort users alphabetically by name
                      .map((user_details) => (
                        <li
                          key={user_details.id}
                          onClick={() => toggleUserSelection(user_details)} // Pass correct user object
                          className={"user-name-list"}
                        >
                          <span className="initial">
                            {selectedPreparedBy.includes(user_details.name) ? (
                              <FaCheckCircle
                                style={{ backgroundColor: "transparent" }}
                              />
                            ) : (
                              user_details.name
                                .charAt(user_details.name.length - 1)
                                .toUpperCase() +
                              user_details.name.charAt(0).toUpperCase()
                            )}
                          </span>{" "}
                          <span
                            style={{
                              backgroundColor: "transparent",
                              marginTop: "2px",
                            }}
                          >
                            {user_details.name}
                          </span>
                        </li>
                      ))}
                  </ul>
                ) : (
                  <ul className="users-ul">
                    <li
                      key={userDetails.id}
                      onClick={() => toggleUserSelection(userDetails)} // Pass correct user object
                      className={"user-name-list"}
                    >
                      <span className="initial">
                        {selectedPreparedBy.includes(userDetails.name) ? (
                          <FaCheckCircle
                            style={{ backgroundColor: "transparent" }}
                          />
                        ) : (
                          userDetails.name
                            .charAt(userDetails.name.length - 1)
                            .toUpperCase() +
                          userDetails.name.charAt(0).toUpperCase()
                        )}
                      </span>{" "}
                      <span
                        style={{
                          backgroundColor: "transparent",
                          marginTop: "2px",
                        }}
                      >
                        {userDetails.name}
                      </span>
                    </li>
                  </ul>
                )}
              </div>

              <div
                className={
                  reviewedByUsersOpen
                    ? "accordion-u-header"
                    : "accordion-header"
                }
                style={{ marginBottom: "-1px" }}
              >
                <h3
                  className="accordion-label"
                  onClick={() => setReviewedByUsersOpen((prev) => !prev)}
                >
                  Reviewed by
                  {selectedReviewedBy.length > 0 && (
                    <span className="users-count">
                      {selectedReviewedBy.length}
                    </span>
                  )}
                </h3>
                {!reviewedByUsersOpen && (
                  <select
                    className="is-not"
                    value={reviewedByCondition}
                    onChange={(e) => setReviewedByCondition(e.target.value)}
                  >
                    <option value="is">Is</option>
                    <option value="not">Is Not</option>
                  </select>
                )}

                <span
                  onClick={() => setReviewedByUsersOpen((prev) => !prev)}
                  className="span-element"
                >
                  {reviewedByUsersOpen ? (
                    <FaChevronRight className="arrow-icon" />
                  ) : (
                    <FaChevronDown className="arrow-d-icon" />
                  )}
                </span>
              </div>

              <div
                className={reviewedByUsersOpen ? "hide" : "filter-name-field"}
                style={{
                  height:
                    userDetails.role_name === "Administrator" ||
                    userDetails.role_name === "Super Admin"
                      ? "133px"
                      : "auto",
                }}
              >
                <ul className="user-ul">
                  {users
                    .sort((a, b) => a.name.localeCompare(b.name)) // Sort users alphabetically by name
                    .map((user_details) => (
                      <li
                        key={user_details.id}
                        onClick={() => toggleReviewedBySelection(user_details)} // Pass correct user object
                        className={"user-name-list"}
                      >
                        <span className="initial">
                          {selectedReviewedBy.includes(user_details.name) ? (
                            <FaCheckCircle
                              style={{ backgroundColor: "transparent" }}
                            />
                          ) : (
                            user_details.name
                              .charAt(user_details.name.length - 1)
                              .toUpperCase() +
                            user_details.name.charAt(0).toUpperCase()
                          )}
                        </span>{" "}
                        <span
                          style={{
                            backgroundColor: "transparent",
                            marginTop: "2px",
                          }}
                        >
                          {user_details.name}
                        </span>
                      </li>
                    ))}
                </ul>
              </div>

              <div
                className={
                  approvedByUsersOpen
                    ? "accordion-u-header"
                    : "accordion-header"
                }
                style={{ marginBottom: "-1px" }}
              >
                <h3
                  className="accordion-label"
                  onClick={() => setApprovedByUsersOpen((prev) => !prev)}
                >
                  Approved by
                  {selectedApprovedBy.length > 0 && (
                    <span className="users-count">
                      {selectedApprovedBy.length}
                    </span>
                  )}
                </h3>
                {!approvedByUsersOpen && (
                  <select
                    className="is-not"
                    value={approvedByCondition}
                    onChange={(e) => setApprovedByCondition(e.target.value)}
                  >
                    <option value="is">Is</option>
                    <option value="not">Is Not</option>
                  </select>
                )}

                <span
                  onClick={() => setApprovedByUsersOpen((prev) => !prev)}
                  className="span-element"
                >
                  {preparedByUsersOpen ? (
                    <FaChevronRight className="arrow-icon" />
                  ) : (
                    <FaChevronDown className="arrow-d-icon" />
                  )}
                </span>
              </div>

              <div
                className={approvedByUsersOpen ? "hide" : "filter-name-field"}
                style={{
                  height:
                    userDetails.role_name === "Administrator" ||
                    userDetails.role_name === "Super Admin"
                      ? "133px"
                      : "auto",
                }}
              >
                <ul className="user-ul">
                  {users
                    .sort((a, b) => a.name.localeCompare(b.name)) // Sort users alphabetically by name
                    .map((user_details) => (
                      <li
                        key={user_details.id}
                        onClick={() => toggleApprovedSelection(user_details)} // Pass correct user object
                        className={"user-name-list"}
                      >
                        <span className="initial">
                          {selectedApprovedBy.includes(user_details.name) ? (
                            <FaCheckCircle
                              style={{ backgroundColor: "transparent" }}
                            />
                          ) : (
                            user_details.name
                              .charAt(user_details.name.length - 1)
                              .toUpperCase() +
                            user_details.name.charAt(0).toUpperCase()
                          )}
                        </span>{" "}
                        <span
                          style={{
                            backgroundColor: "transparent",
                            marginTop: "2px",
                          }}
                        >
                          {user_details.name}
                        </span>
                      </li>
                    ))}
                </ul>
              </div>
              <div
                className={
                  phaseOpen ? "accordion-u-header" : "accordion-header"
                }
                style={{ marginBottom: "-1px" }}
              >
                <h3
                  className="accordion-label"
                  onClick={() => setPhaseOpen((prev) => !prev)}
                >
                  Phase
                  {selectedPhase.length > 0 && (
                    <span className="users-count">
                      {selectedPhase.length > 0 ? 1 : 0}
                    </span>
                  )}
                </h3>
                {!phaseOpen && (
                  <select
                    className="is-not"
                    value={phaseCondition}
                    onChange={(e) => {
                      setPhaseCondition(e.target.value);
                    }}
                  >
                    <option value="is">Is</option>
                    <option value="not">Is Not</option>
                  </select>
                )}
                <span
                  onClick={() => setPhaseOpen((prev) => !prev)}
                  className="span-element"
                >
                  {phaseOpen ? (
                    <FaChevronRight className="arrow-icon" />
                  ) : (
                    <FaChevronDown className="arrow-d-icon" />
                  )}
                </span>
              </div>
              {!phaseOpen && (
                <div>
                  <select
                    className="overview-phase-dd"
                    value={selectedPhase}
                    onChange={(e) => {
                      const phaseValue = e.target.value;
                      setSelectedPhase(phaseValue);
                    }}
                  >
                    <option disabled value="">
                      Select Phase
                    </option>
                    {phases.map((phase) => (
                      <option key={phase.id} value={phase.id}>
                        {phase.title}
                      </option>
                    ))}
                  </select>
                  {/* <ul className="user-ul">
                    {phases.map((phase) => (
                      <li
                        key={phase.id}
                        onClick={() => setSelectedPhase(phase.id)} // Pass correct user object
                        className={"user-name-list"}
                      >
                        <span className="initial">
                          {selectedPhase.includes(phase.id) ? (
                            <FaCheckCircle
                              style={{ backgroundColor: "transparent" }}
                            />
                          ) : (
                            phase.title
                              .charAt(phase.title.length - 1)
                              .toUpperCase() +
                            phase.title.charAt(0).toUpperCase()
                          )}
                        </span>{" "}
                        <span
                          style={{
                            backgroundColor: "transparent",
                            marginTop: "2px",
                          }}
                        >
                          {phase.title}
                        </span>
                      </li>
                    ))}
                  </ul> */}
                </div>
              )}
              <div
                className={
                  statusOpen ? "accordion-u-header" : "accordion-header"
                }
                style={{ marginBottom: "-1px" }}
              >
                <h3
                  className="accordion-label"
                  onClick={() => setStatusOpen((prev) => !prev)}
                >
                  Status
                  {selectedStatus.length > 0 && (
                    <span className="users-count">
                      {selectedStatus.length > 0 ? 1 : 0}
                    </span>
                  )}
                </h3>
                {!statusOpen && (
                  <select
                    className="is-not"
                    value={statusCondition}
                    onChange={(e) => {
                      setStatusCondition(e.target.value);
                    }}
                  >
                    <option value="is">Is</option>
                    <option value="not">Is Not</option>
                  </select>
                )}
                <span
                  onClick={() => setStatusOpen((prev) => !prev)}
                  className="span-element"
                >
                  {statusOpen ? (
                    <FaChevronRight className="arrow-icon" />
                  ) : (
                    <FaChevronDown className="arrow-d-icon" />
                  )}
                </span>
              </div>
              {!statusOpen && (
                <div>
                  <select
                    className="overview-phase-dd"
                    value={selectedStatus}
                    onChange={(e) => setSelectedStatus(e.target.value)}
                  >
                    <option disabled value="">
                      Select Status
                    </option>
                    <option value="Open">Open</option>
                    <option value="Outstanding">Outstanding</option>
                    <option value="Closed">Closed</option>
                  </select>
                </div>
              )}
            </div>

            <div className="timesheet-btn-container-add-timesheet">
              <button
                className="add-btn"
                onClick={handleApplyFilters}
                style={{ marginLeft: "5px", fontWeight: "600px" }}
              >
                Apply
              </button>
              <button
                onClick={() => setOpenDialog(false)}
                className="cancel-btn"
                style={{ fontWeight: "600px" }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RfiFilter;
